"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerSetSchema = void 0;
const zod_1 = require("zod");
const ModelBase_1 = require("../ModelBase");
const Layer_1 = require("./Layer");
exports.LayerSetSchema = zod_1.z.object({
    type: zod_1.z.literal('layerSet'),
    id: zod_1.z.string(),
    layerSetType: ModelBase_1.ModelTypeSchema,
    layers: Layer_1.LayerSchema.array(),
});
//# sourceMappingURL=LayerSet.js.map